// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"520":"70511a8e","780":"eb5754ec"}[chunkId] + ".chunk.css";
};